import { styled } from "@linaria/react";

export const ListCard = styled.ul`
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
  background: var(--group);
  border: 1px solid var(--group-border);
  border-radius: 10px;
  box-shadow: var(--group-shadow);
  overflow: hidden;
  position: relative;
`;
